import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";
import './ModalAct.scss'
import { Invoice } from '../../../components/Documents/Invoice/Invoice';
import { useState, useEffect } from "react";
import customHeaders, { getSpace } from '../../../common/headers';
import { useResponseHandler } from "../../../common/auth";
import useGeneralStore from "../../../store/general";

const ModalAct = ({
    setIsModal,
    selectedAct,
    setSelectedAct
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)

    const fetchDataAct = () => {
        let url = `https://apps0.ecomru.ru:4440/invoice?invoiceNumber=${selectedAct}`;

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => setData(json?.invoice))
            .catch(handleRequestError)
            .finally(() => setLoading(false))
    };

    useEffect(() => {
        fetchDataAct()
    }, [selectedAct]);

    return (
        <ModalComponent
            onClose={e => {
                setIsModal(false)
                setSelectedAct(null)
            }}
            loading={loading}
            title={`Счет №-${selectedAct}`}
            child={
                <div className='modal-act'>
                    <Invoice
                        data={data}
                    />
                </div>
            }
        />
    )
}

export { ModalAct }